import { selectorFamily } from 'recoil';

import axios from '../../common/axiosInterceptor';
import { normalizePhoneSearch } from '../../common/helperFunctions/phoneSearchNormalizer';
import { getApiMutation } from '../../services/rest/getApiMutation';
import { endpointEnum } from '../../services/rest/makeAPIRequest';
import { endingDate } from '../atoms/endingDate';
import { startingDate } from '../atoms/startingDate';
import { user } from '../atoms/user';

import { methodNameEnum } from './makePHPRequest';

const columns = [
  {
    data: 0,
    name: 'phpcallstring',
    searchable: false,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 1,
    name: '',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 2,
    name: 'callid',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 3,
    name: 'externalid',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 4,
    name: '',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 5,
    name: 'calltype',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 6,
    name: 'callstatus',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 7,
    name: 'disposition',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 8,
    name: 'duration',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 9,
    name: 'inside',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 10,
    name: 'outside',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 11,
    name: 'amount',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 12,
    name: 'pcActions',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 13,
    name: 'source',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 14,
    name: 'sourcename',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
  {
    data: 15,
    name: 'transcriptionStrength',
    searchable: false,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
];

export const callHistoryAdmin2 = selectorFamily({
  key: 'callHistoryAdmin2',
  get: ({
    page,
    pageSize,
    sortModel,
    search = '',
    agentId = null,
    superadmin = false,
  }) => async ({ get }) => {
    try {
      const startdate = get(startingDate);
      const enddate = get(endingDate);
      const storageUser = get(user);
      let userID = {};
      const data = {
        call: methodNameEnum.GET_BUSINESS_DATA,
      };
      const mutation = getApiMutation(storageUser);
      const businessData = await mutation({
        endpoint: endpointEnum.GET_BUSINESS_DATA,
        payload: data,
      });

      // do not continue if user atom not populated
      if (
        !storageUser.businessid ||
        !storageUser.apikey ||
        !businessData.data.success
      ) {
        return {};
      }

      // translate sortModel to order
      const order = sortModel?.field
        ? columns
            .filter((col) => col.name === sortModel.field)
            .map((col) => ({
              column: col.data,
              dir: sortModel.sort,
            }))
        : undefined;

      if (agentId) {
        userID = {
          userid: agentId,
        };
      }

      const response = await axios.post(
        `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/getcallhistoryadmin2`,
        JSON.stringify({
          call: 'getBusinessCallHistory',
          businessid: storageUser.businessid,
          apiKey: storageUser.apikey,
          search: {
            value: normalizePhoneSearch(search)?.[0] || search,
            regex: false,
          },
          superadmin,
          start: (page - 1) * pageSize,
          length: pageSize,
          startdate: startdate,
          enddate: enddate,
          react: 1,
          draw: 1,
          timezone: businessData?.data?.result?.[0]?.timezone_php,
          columns,
          order,
          ...userID,
        })
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
});
